module.exports = __webpack_public_path__ + "img/arrow_down_red_24dp@2x.d3b41872.png";